import { Segment } from '@/types/Segment';

export const convertSegmentsToSnakeCase = ({ orderId, ...rest }: Segment) => ({
  ...rest,
  order_id: orderId,
});
